module.exports = {"220402070":"辽源经济开发区（特殊街道）","220402100":"寿山镇","220402198":"县级直管村级单位（特殊镇）","220402200":"工农乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220402.json
// module id = 635
// module chunks = 0